export default {
      id: "circle-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#circle",
      toString: function () {
        return this.url;
      }
    }